import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
// Import components
import { defineComponent } from "vue";
import { ElMessageBox } from 'element-plus';
import GHSubCategory from "@/components/GHSubCategory";
import { get_category_components, get_component_from_name, get_setting } from "@/service/api";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "@/assets/styles/driver.css";
import { mapActions, mapState } from 'vuex';
import { appPath } from "@/config/settings";
import { get_toolset_name_from_full_path } from "../utils/path";
import { isCategoryVisible } from "@/utils/rhinoVersion";
import SuperGif from "@/utils/libgif.js";
export default defineComponent({
  name: "GrasshopperTabs",
  components: {
    GHSubCategory
  },
  props: {
    categories: [Object]
  },
  setup() {
    let search_list = null;
    return {
      search_list
    };
  },
  computed: {
    ...mapState({
      rows_count: state => state.component_rows,
      // 更新为 component_rows
      highlightedIconId: state => state.highlightedIconId,
      // 添加 highlightedIconId
      current_rhino_version: state => state.current_rhino_version,
      // 当前 Rhino 版本，用于过滤 Category
      searchNavigationId: state => state.searchNavigationId,
      // 本次跳转是否来自搜索框，用于触发聚焦动效
      focusIconId: state => state.focusIconId // 正在做聚焦动效的图标，遮罩的透明孔对准它
    }),
    // 当前 Rhino 版本下有可见组件的 Category。
    // 数据尚未加载完成前先保留该 Category，避免预加载期间出现空白闪烁。
    visibleCategories() {
      return this.categories.filter(category => {
        const entry = this.allCategories[category.name];
        if (!entry || !entry.subCategoriesLoaded) {
          return true;
        }
        return isCategoryVisible(entry, this.current_rhino_version);
      });
    },
    // 聚焦遮罩叠在图标区上方的一层暗色，中心留一个透明孔给目标图标。
    // 孔的位置要用目标图标相对遮罩宿主的实时坐标：图标会随分类、卷起滚动而移动，
    // 写死偏移会对不上。找不到图标时（刚路由过去还没渲染）返回 null，遮罩不显示。
    focusMaskStyle() {
      const id = this.focusIconId;
      if (!id) {
        return null;
      }
      // 原点必须取遮罩的宿主 .tabs-wrapper，不是 .icon-area：遮罩是 absolute
      // 定位在 wrapper 上的，而 icon-area 还要再往下压一个 tab 标签栏的高度。
      // 用 icon-area 当原点算，孔会整体上移那么多个像素，看着就是没对齐。
      const host = this.$el.querySelector('.tabs-wrapper');
      if (!host) {
        return null;
      }
      const target = this.$el.querySelector(`.GHOperator[data-id="${id}"]`);
      if (!target || target.offsetParent === null) {
        return null;
      }
      const h = host.getBoundingClientRect();
      const t = target.getBoundingClientRect();
      // 遮罩从 tab 标签栏下方开始：标签栏是导航，压暗它反而让人不知道自己在
      // 哪个分类里，失去「压暗后还在原地」的方向感。高度实测而不是写死，
      // 不同 Element Plus 版本 / 字体下的 header 高度并不一致。
      const tabsHeader = host.querySelector('.el-tabs__header');
      const maskTop = tabsHeader ? tabsHeader.offsetHeight : 0;
      // 渐变里的 at X/Y 是相对「遮罩盒子顶边」的，而上面拿的是相对宿主
      // （.tabs-wrapper）顶边的坐标。遮罩往下挪了 maskTop，孔就要同样往下
      // 挪这么多，否则整块亮区会停在图标上方 maskTop 像素处。
      // 孔要比图标略大一圈，让图标本身完整透出、边缘还能看到一圈暗色收边
      const holeX = t.left - h.left + t.width / 2;
      const holeY = t.top - h.top + t.height / 2 - maskTop;
      const holeR = Math.max(t.width, t.height) * 1.05;
      return {
        '--focus-top': `${maskTop}px`,
        '--focus-x': `${holeX}px`,
        '--focus-y': `${holeY}px`,
        '--focus-r': `${holeR}px`
      };
    },
    // 卷起时图标区的两个高度：实心段刚好完整露出第一个子分类块（含它的名称栏），
    // 再往下留一段渐隐带淡出第二个子分类。
    // 实测单个子分类块 = 图标行(rows*42px) + 24px 名称栏 + 上下共 12px 外边距
    collapsedAreaStyle() {
      const solid = this.rows_count * 42 + 36;
      return {
        '--collapsed-solid': `${solid}px`,
        '--collapsed-h': `${solid + 44}px`
      };
    },
    // 参数表格下方是否有范例内容（后端在 Custom Content Area 编辑上传的内容）。
    // bottom_content 是 HTML 片段，而不少组件的范例只有一张图、没有文字，
    // 所以纯文本为空时还要再看有没有媒体标签，否则图片范例会被误判成空
    hasBottomContent() {
      const html = this.currentComponent && this.currentComponent.bottom_content;
      if (!html) {
        return false;
      }
      const raw = String(html);
      const hasMedia = /<(img|iframe|video|svg|embed|object)\b/i.test(raw);
      const text = raw.replace(/<[^>]*>/g, '').replace(/&nbsp;|\s/g, '');
      return text.length > 0 || hasMedia;
    },
    // 只有一行参数时，折叠态的遮罩会正好盖住唯一的这行数据（遮罩按固定 84px
    // 裁剪，而表头就占了 48px），折叠也就失去了意义——所以此时不提供切换，
    // 表格始终完整展开。输入、输出两侧各判一次：有的组件是单行输入 + 多行输出。
    canCollapseInput() {
      return this.paramCount(this.currentComponent.input_params) > 1;
    },
    canCollapseOutput() {
      return this.paramCount(this.currentComponent.output_params) > 1;
    },
    thisAppPath() {
      if (this.$route && this.$route.path) {
        const pathParts = this.$route.path.split('/');
        // Expected path structure like /level1/level2/...
        // e.g., /docs/grasshopper/...
        // We want to extract /level1/level2 which is /docs/grasshopper
        if (pathParts.length > 2 && pathParts[1] && pathParts[2]) {
          return `/${pathParts[1]}/${pathParts[2]}`;
        }
      }
      // Fallback using imported appPath (from @/config/settings) and a default sub-path
      // Note: 'appPath' here refers to the imported constant, not a component property.
      return `${appPath}grasshopper`; // e.g., if appPath is "/docs/", this becomes "/docs/grasshopper"
    },
    descriptionLines() {
      if (this.currentComponent && this.currentComponent.description) {
        // Split by newline characters and filter out empty lines
        return this.currentComponent.description.split('\n').filter(line => line.trim() !== '');
      }
      return [];
    }
  },
  data() {
    return {
      isSubLoading: true,
      isCompLoading: false,
      // 顶部组件图标区是否卷起。窄屏（<768px）默认卷起：移动端竖屏放不下几行图标，
      // 展开时会把组件标题和参数表整个顶到屏幕外，而图标本身大多用不上。
      // 判据与 isMobileView 一致。只在首次加载时决定，之后用户手动展开/收起的结果
      // 不再被覆盖——否则横竖屏切换一下就会把用户刚展开的面板又收回去。
      iconsCollapsed: window.innerWidth < 768,
      // 参数表格折叠状态，初始值只是占位；
      // 组件加载完后由 applyParamTableCollapseDefault 按下方有无范例内容决定
      inputTableCollapsed: true,
      // Input parameters 表格是否折叠
      outputTableCollapsed: true,
      // Output parameters 表格是否折叠
      currentTabName: "",
      allCategories: {},
      // 搜索跳转聚焦动效的计时器。连续搜多个组件时新的会覆盖旧的，
      // 避免两次动效叠在一起、或第二次滚回详情时第一次还在等
      focusTimers: [],
      // 本轮正在做聚焦动效的图标 id，防止 currentComponent 的 deep watcher
      // 重复启动同一轮流程
      focusingIconId: null,
      pendingCategoryLoads: {},
      // 进行中的分类组件请求，用于去重
      currentCategory: {},
      allComponents: {},
      currentComponent: {},
      topText: "",
      topTip: {},
      diyTop: "",
      diyBottom: "",
      drawer: false,
      highlightedIconId: null,
      // New: Used to store the currently highlighted icon ID
      driverObj: null,
      // 引导演示过程中需要还原的初始状态。每轮 drive() 前重新记录，
      // 引导一结束就拿它把界面恢复原样，免得演示把用户的页面留在奇怪的状态上。
      guideDemo: {
        collapsedAtStart: false
      },
      // 引导演示用的定时器。每进入一个新步骤就清空上一轮还没跑的演示，
      // 否则用户点得比演示快时，上一步的点击会落到下一步的界面上
      guideDemoTimers: [],
      isMobileView: window.innerWidth < 768,
      gifPlayers: [],
      // 存储 libgif.js 实例，用于组件卸载时销毁释放
      // Start Guide 的步骤。element 找不到对应 DOM 的步骤会在 initGuide 里被剔掉，
      // 所以新增步骤不必关心目标区域此刻是否已经渲染出来。
      guideSteps: [{
        desktop: '.el-tabs__nav',
        mobile: '.el-tabs__nav',
        popover: {
          title: 'Component Categories',
          description: 'Click any tab to switch category.',
          side: "bottom",
          align: 'start'
        },
        // 高亮之后自动点两三个别的分类，再点回最初那个。
        // 只看图示学不会「点标签会跳走」，而这正是新手最容易忽略的一步。
        // 点的是真的 DOM 节点，走的也是用户点击那条路
        // （el-tabs 的 tab-click → 路由跳转 → 载入该分类的组件）。
        // 最后必须切回原分类：引导是讲解，不该把用户留在一个他没选的地方。
        onHighlight: () => {
          const items = this.guideTabItems();
          const original = document.querySelector('.el-tabs__item.is-active');
          if (!original || items.length < 2) {
            return;
          }
          // 按名字而不是按节点找回原来的分类：每次点击都会触发路由跳转并重建
          // tab 节点，存下来的引用点下去只会点到已经废弃的元素上
          const originalName = original.textContent.trim();
          const start = items.indexOf(original);
          const visits = [1, 2].map(step => items[(start + step) % items.length].textContent.trim());
          // 演示没演完之前锁住「下一步」。用户手快点下去的话，这一步的演示
          // 会被 clearGuideDemoTimers 直接掐掉——标签确实切了，但切了几个、
          // 有没有切回来，全都来不及看见，等于白演。
          this.lockGuideAdvance(1400 * (visits.length + 2));
          visits.forEach((name, i) => {
            this.scheduleGuideDemo(() => this.clickGuideTab(name), 1400 * (i + 1));
          });
          this.scheduleGuideDemo(() => this.clickGuideTab(originalName), 1400 * (visits.length + 1));
        }
      }, {
        desktop: '.el-tabs__content',
        mobile: '.el-tabs__content',
        popover: {
          title: 'Component Icons',
          description: 'Click an icon to open its documentation.',
          side: "bottom",
          align: 'start'
        }
      }, {
        desktop: '.rhino-version-badge',
        mobile: '.rhino-version-badge',
        popover: {
          title: 'Rhino Version',
          description: 'Only components available in this version are listed.',
          side: "bottom",
          align: 'start'
        }
      }, {
        desktop: '.icon-area-toggle',
        mobile: '.icon-area-toggle',
        popover: {
          title: 'Collapse / Expand',
          description: 'Fold the icon panel away to free up space.',
          side: "bottom",
          align: 'start'
        },
        // 自动点两下：折一次给用户看效果，再折回去。
        // 两下之后图标区必然回到进引导时的样子，不留痕迹——
        // 窄屏默认就是卷起的，照样成立，那时是展开给用户看再收回去。
        onHighlight: element => {
          // 同上：两下点完、还原动画走完之前不放开「下一步」
          this.lockGuideAdvance(4000);
          this.scheduleGuideDemo(() => {
            element.click();
            this.refreshGuideWhileMoving();
          }, 1400);
          this.scheduleGuideDemo(() => this.restoreIconArea(element), 2900);
        },
        // 兜底：用户比演示走得快时，第二下还没轮到就离开了这步，
        // 这时把状态还原回去，别把图标区留在折起/展开的反面
        onLeave: element => this.restoreIconArea(element)
      }, {
        desktop: '.input-with-select',
        mobile: '.input-with-select',
        popover: {
          title: 'Search Bar',
          description: 'Type a component name to jump straight to it.',
          side: "bottom",
          align: 'start'
        }
      }, {
        desktop: '.menubutton',
        mobile: '.menubutton',
        popover: {
          title: 'Sidebar Menu',
          description: 'Opens settings for the <strong>Rhino version</strong>, <strong>row count</strong>, and <strong>filters</strong>.',
          side: "left",
          align: 'start'
        },
        // 拉开抽屉让用户看清里面有什么，停留片刻，再模拟点空白处把它收起——
        // 顺带把「点外面就能关」这件事也演示了。
        // 抽屉弹出的一瞬间就把卡片整个藏掉：卡片正好压在抽屉上半截，
        // 半透明也看不清，不如让开，把抽屉完整露给用户。
        // Done 也要锁到卡片回来为止：那几秒卡片不可见，Done 跟着一起消失，
        // 用户看不到按钮在哪，这时候点下去只会觉得是坏的。
        onHighlight: element => {
          this.lockGuideAdvance(5400);
          this.scheduleGuideDemo(() => {
            this.hideGuidePopover();
            element.click();
          }, 1400);
          this.scheduleGuideDemo(() => this.closeSidebarDrawer(), 4600);
          // 卡片等抽屉滑出去之后再回来，免得两者在屏幕上撞个正着
          this.scheduleGuideDemo(() => this.restoreGuidePopover(), 5000);
        }
      }]
    };
  },
  watch: {
    // 切换 Rhino 版本后，若当前选中的 Category 在该版本下已无可见组件，
    // 自动切到第一个可见的 tab，避免停留在空白页面上
    current_rhino_version() {
      this.ensureCurrentCategoryVisible();
    },
    categories(newValue) {
      newValue.forEach(item => {
        this.allCategories[item.name] = {
          "id": item.id,
          "name": item.name,
          "subCategories": [],
          "subCategoriesLoaded": false
        };
      });
      this.initCurrentCategory();
      this.initCurrentComponent();
      this.preloadAllCategories();
    },
    // Watch route
    '$route': {
      handler(to) {
        // If categories haven't been initialized, let initCurrentCategory handle it, don't do anything here.
        if (this.categories[0] === undefined) {
          return;
        }
        if (to.params.categoryName === undefined) {
          let categoryName = this.categories[0].name;
          this.setCurrentCategory(categoryName);
        }
        // If there's a category name in the route, set the current category
        this.setCurrentCategory(to.params.categoryName);
        if (to.params.nameInUrl === undefined) {
          return;
        }
        this.isCompLoading = true;
        this.setCurrentComponent(to.params.categoryName, to.params.nameInUrl);
      },
      immediate: true
    },
    // 搜索跳转标记：路由一变就启动聚焦动效，不必等组件数据返回
    searchNavigationId: {
      handler(id) {
        if (id) {
          this.focusIconFromSearch(id);
        }
      },
      immediate: false
    },
    // Add a new watcher for currentComponent
    currentComponent: {
      handler() {
        // 聚焦动效期间不让它抢滚动：光晕播完会自己调 scrollToCurrentComponent。
        // 这里提前跳过，避免组件数据一回来就把详情顶上去、光晕还在滚动的中途
        if (this.focusingIconId) {
          return;
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToCurrentComponent();
          }, 500);
        });
      },
      deep: true
    }
  },
  beforeMount() {
    get_setting('GhTopText').then(result => {
      this.topText = result.data.text;
    });
    get_setting('GhTopTip').then(result => {
      result.data.key_value.forEach(item => {
        if (item.key === 'title') this.topTip['title'] = item.value;
        if (item.key === 'content') this.topTip['content'] = item.value;
      });
    });
    get_setting('diy_top').then(result => {
      this.diyTop = result.data.html;
    });
    get_setting('diy_bottom').then(result => {
      this.diyBottom = result.data.html;
    });
  },
  mounted() {
    // Monitor window size changes
    window.addEventListener('resize', this.handleResize);
    // Initialize the boot object
    this.initGuide();
  },
  updated() {
    // 清理已不在 DOM 中的 player 引用，避免内存泄漏
    this.gifPlayers = this.gifPlayers.filter(p => {
      if (!p.wrapper.isConnected) {
        if (p.rub) p.rub.pause();
        return false;
      }
      return true;
    });
    this.initGifControls();
  },
  beforeUnmount() {
    // Remove event listener
    window.removeEventListener('resize', this.handleResize);
    this.destroyGifControls();
    // 引导演示的定时器：组件销毁后仍会回调，届时再去点页面上的元素就点空了
    this.clearGuideDemoTimers();
    // 聚焦动效的计时器若没清掉，组件销毁后仍会回调并操作已不存在的 DOM
    this.clearFocusTimers();
  },
  provide() {
    return {
      staticValue: this.staticValue,
      // Return value directly, not reactive
      staticObject: this.staticObject,
      // Return an object, reactive
      getReactiveValue: () => this.staticValue // Return a function that returns an object, reactive
    };
  },
  methods: {
    ...mapActions({
      get_local_rows: "get_local_rows",
      set_local_rows: "set_local_rows"
    }),
    handleResize() {
      this.isMobileView = window.innerWidth < 768;
      // 如果引导正在进行中，重新初始化引导
      if (this.driverObj) {
        this.initGuide();
      }
    },
    // 参数行数。后端给的是数组，防御性地兼容非数组（避免 .length 之外的意外）
    paramCount(params) {
      return Array.isArray(params) ? params.length : 0;
    },
    // 按当前视口的选择器反查步骤配置。driver 的回调里拿得到的索引在
    // onDeselected 触发时还指向「正在离开的那一步」，用元素反查更保险，
    // 也省掉了一份和 steps 平行、容易走样的数组。
    guideStepFor(element) {
      if (!element || !element.matches) {
        return null;
      }
      const selector = this.isMobileView ? 'mobile' : 'desktop';
      return this.guideSteps.find(step => element.matches(step[selector])) || null;
    },
    // 当前高亮的是不是第一步。拿配置里的第一个选择器比对，不看步骤下标——
    // initGuide 会剔掉目标还没渲染出来的步骤，实际跑起来的第一步未必是配置里的第一个。
    isFirstGuideStep(element) {
      if (!element || !element.matches) {
        return false;
      }
      const selector = this.isMobileView ? 'mobile' : 'desktop';
      return element.matches(this.guideSteps[0][selector]);
    },
    // 引导演示的延时动作。高亮动画和卡片入场要先把位置跑完，
    // 演示再跟着做；早一步用户只会看到界面自己乱动。
    scheduleGuideDemo(fn, delay) {
      this.guideDemoTimers.push(setTimeout(fn, delay));
    },
    clearGuideDemoTimers() {
      this.guideDemoTimers.forEach(t => clearTimeout(t));
      this.guideDemoTimers = [];
      // 解锁也要跟着一起作废：解锁定时器正是被这句清掉的，不在这里补一把，
      // 用户在锁定期间点 Previous 离开那一步，锁就残留在页面上，
      // 之后每一步的「下一步」都是灰的，提示条也赖着不走。
      this.unlockGuideAdvance();
    },
    // 可见的分类标签（Element Plus 会把所有 tab-pane 都预渲染，
    // 隐藏的分类名不能点）
    guideTabItems() {
      return Array.from(document.querySelectorAll('.el-tabs__item')).filter(item => item.offsetParent !== null);
    },
    clickGuideTab(name) {
      const item = this.guideTabItems().find(el => el.textContent.trim() === name);
      if (item) {
        item.click();
      }
    },
    // 把图标区还原成进引导时的卷起/展开状态
    restoreIconArea(element) {
      if (this.iconsCollapsed !== this.guideDemo.collapsedAtStart) {
        element.click();
        this.refreshGuideWhileMoving();
      }
    },
    // 图标区卷起/展开走的是 max-height 过渡（.35s），按钮在这段时间里一直在移动。
    // driver 的高亮框和卡片是按高亮那一刻的位置摆好的，不会自己跟着走，
    // 于是演示卷起之后，高亮框和卡片就留在了按钮原来的位置上。
    // 过渡期间隔一小段时间刷一次定位，等它跑完自然就落在最终位置了。
    // 走 scheduleGuideDemo 而不是裸 setTimeout：用户中途切步骤时会被一起清掉，
    // 不会在新的一步上继续刷。
    refreshGuideWhileMoving(duration = 800) {
      const start = Date.now();
      const tick = () => {
        if (this.driverObj && this.driverObj.isActive()) {
          this.driverObj.refresh();
        }
        if (Date.now() - start < duration) {
          this.scheduleGuideDemo(tick, 60);
        }
      };
      tick();
    },
    // 抽屉弹出期间把引导卡片整个藏起来，连 Previous / Done 一起，
    // 让抽屉完整地露给用户看。收起后由 restoreGuidePopover 恢复。
    // 用 visibility 而不是 display：卡片还占着原来的位置，
    // 万一这时重定位，不会因为量到 0 而被甩到左上角。
    hideGuidePopover() {
      document.body.classList.add('guide-popover-hidden');
    },
    restoreGuidePopover() {
      document.body.classList.remove('guide-popover-hidden');
      this.unlockGuideAdvance();
    },
    // 演示期间锁住「下一步」，到期自动放开。
    // 只锁下一步：Previous 和关闭按钮照常可用，用户随时能自己跳过演示。
    // 这两个状态类都挂在 body 上而不是卡片上：driver.js 的 onHighlightStarted
    // 是在 popover 渲染之前触发的，那时页面上还查不到 .driver-popover，
    // 挂在卡片上的话第一步的锁会静悄悄地加不上。
    // 用 CSS 类而不是 disabled 属性——driver.js 换步骤时会重建 footer 按钮
    // 并直接改它们的属性，挂在按钮上的 disabled 会被冲掉。
    // 时长同时写进 --guide-demo-fill：按钮上那条填充进度要跑满同样的时间，
    // 填完正好就是解锁的那一刻，用户看到的是「演示完成了，点吧」。
    lockGuideAdvance(unlockAfter) {
      document.body.style.setProperty('--guide-demo-fill', `${unlockAfter}ms`);
      document.body.classList.add('guide-advance-locked');
      this.scheduleGuideDemo(() => this.unlockGuideAdvance(), unlockAfter);
    },
    unlockGuideAdvance() {
      document.body.classList.remove('guide-advance-locked');
    },
    // 点侧边抽屉外的空白处把它关掉——真实用户就是这么关的。
    // 必须自己按 mousedown → mouseup → click 的顺序派发：el-overlay 用
    // useSameTarget 判断，只有这两次都落在遮罩自身上，后面的 click 才被接住。
    // element.click() 只发 click，会被静默丢掉，抽屉根本不会关。
    // 先按 .menudrawer 定位再往上找遮罩：页面里 select / autocomplete 也会
    // 生成 .el-overlay，直接取第一个可能关掉的是别的东西。
    closeSidebarDrawer() {
      const drawer = document.querySelector('.menudrawer');
      if (!drawer || drawer.getClientRects().length === 0) {
        return;
      }
      const overlay = drawer.closest('.el-overlay');
      if (overlay) {
        ['mousedown', 'mouseup', 'click'].forEach(type => {
          overlay.dispatchEvent(new MouseEvent(type, {
            bubbles: true,
            cancelable: true,
            view: window
          }));
        });
      }
    },
    initGuide() {
      // 剔掉目标还没渲染出来的步骤。图标区整块挂在 .tabs-wrapper 上、由分类数据
      // 到位后才出现，而 Start Guide 按钮从页面一开始就在，用户完全可能先点它——
      // 这时 driver.js 找不到元素会直接抛 MissingElementError，引导整个打不开。
      // 少两步总比整个引导崩掉好。查 document 而不是 this.$el：搜索框和侧栏按钮
      // 在 Layout 里，不在当前组件的根节点内。
      const steps = this.guideSteps.map(step => ({
        element: this.isMobileView ? step.mobile : step.desktop,
        popover: step.popover
      })).filter(step => document.querySelector(step.element));

      // 记录进场时的状态，演示过程中的改动都要能还原回去
      this.guideDemo = {
        collapsedAtStart: this.iconsCollapsed
      };
      this.driverObj = driver({
        showProgress: true,
        allowClose: false,
        overlayClickNext: false,
        showButtons: true,
        showClose: true,
        popoverClass: 'driver-popover-custom',
        animate: true,
        opacity: 0.7,
        stagePadding: 5,
        stageRadius: 5,
        steps: steps,
        onHighlightStarted: element => {
          // 换步骤就作废上一轮还没跑的演示：用户点得比演示快时，
          // 迟到的点击会落到已经不相关的一步上去
          this.clearGuideDemoTimers();
          element.style.pointerEvents = 'auto';
          // 第一步没有上一步。driver 自己只会把 Previous 置灰，不会藏起来，
          // 一个点不动的 Previous 摆在最前面反而让人以为引导坏了。
          // 这里只记个标记，让 CSS 藏它——用 visibility 而不是 display，
          // 否则 footer 会重新排版，Next 整条往左挪，每一步的按钮位置都对不上。
          document.body.classList.toggle('guide-first-step', this.isFirstGuideStep(element));
          // 演示动作必须放在 pointerEvents 放开之后：driver 默认给高亮元素
          // 加 pointer-events:none，不放开的话下面的 click() 是空转
          const step = this.guideStepFor(element);
          if (step && step.onHighlight) {
            step.onHighlight(element);
          }
        },
        onDeselected: element => {
          this.clearGuideDemoTimers();
          if (element) {
            element.style.pointerEvents = '';
          }
          const step = this.guideStepFor(element);
          if (step && step.onLeave) {
            step.onLeave(element);
          }
        },
        // 自己接管「下一步」：driver 只在没提供这个回调时才用默认推进，
        // 接管后必须自己调，否则点 Next 不会有反应
        onNextClick: (element, step, opts) => {
          if (opts.driver.isLastStep()) {
            opts.driver.destroy();
          } else {
            opts.driver.moveNext();
          }
        },
        onCloseClick: (element, step, opts) => opts.driver.destroy(),
        // 收尾兜底：引导可能不是从最后一步结束的（中途关闭、点遮罩），
        // 这时侧边抽屉还开着会把整个页面挡住，演示的定时器也还会继续点
        onDestroyed: () => {
          this.clearGuideDemoTimers();
          this.closeSidebarDrawer();
          this.restoreGuidePopover();
        }
      });
    },
    startGuide() {
      // Ensure reinitializing the bootstrap in the current view.
      this.initGuide();
      // bootloader
      this.driverObj.drive();
    },
    handleClickTab(tab) {
      const toolsetName = get_toolset_name_from_full_path(this.$route.path);
      const to = `${appPath}${toolsetName}/${tab.props.label}/`;
      // When clicking a tab, only change the route here, and set the corresponding model switch in the route watcher
      this.$router.push({
        path: `${to}`
      });
    },
    watchvideo() {
      ElMessageBox.alert('Please ensure you have purchased this course before watching this video. If you haven\'t, please click the "Experience" button in the dropdown menu.', 'Watch Reminder:', {
        confirmButtonText: 'I understand',
        confirmButtonClass: 'btnconfirm',
        lockScroll: false,
        callback: action => {
          this.$message({
            type: 'info',
            message: `action: ${action}`
          });
        }
      });
    },
    // fontweight(column){
    //   if(column.columnIndex === 0)
    //   {return "font-weight:bold;font-size:14px;"}
    // },
    headerCellStyle({
      columnIndex
    }) {
      let style = {
        background: 'rgb(180,180,180)',
        color: '#ffffff',
        border: '1px solid #F4F4F5'
      };
      if (columnIndex === 3) {
        style.paddingLeft = '10px';
        style.paddingRight = '10px';
      }
      return style;
    },
    cellStyle({
      columnIndex
    }) {
      let style = {
        fontWeight: 'normal'
      };
      if (columnIndex === 0) {
        style.fontWeight = 'bold';
        return style;
      } else if (columnIndex === 3) {
        style.borderLeft = '1px solid #F4F4F5';
        style.paddingLeft = '10px';
        style.paddingRight = '10px';
      } else {
        style.borderLeft = '1px solid #F4F4F5';
        style.borderRight = '1px solid #F4F4F5';
      }
      return style;
    },
    setCurrentCategory(categoryName) {
      this.currentCategory = this.allCategories[categoryName];
      this.currentTabName = categoryName;
      if (this.currentCategory !== undefined && !this.currentCategory.subCategoriesLoaded) {
        this.loadCategoryComponents(categoryName).then(() => {
          this.setCurrentCategory(categoryName);
        });
      }
    },
    // 加载指定 Category 的组件数据。已加载完成则直接返回，进行中的请求复用同一个 promise。
    loadCategoryComponents(categoryName) {
      const entry = this.allCategories[categoryName];
      if (entry === undefined || entry.subCategoriesLoaded) {
        return Promise.resolve();
      }
      if (this.pendingCategoryLoads[categoryName] !== undefined) {
        return this.pendingCategoryLoads[categoryName];
      }
      const loading = get_category_components(entry.id).then(result => {
        const target = this.allCategories[categoryName];
        if (target === undefined) return;
        target.subCategoriesLoaded = true;
        if (result.data.length !== 0) {
          target.subCategories = result.data;
        }
      }).catch(error => {
        // 失败时同样标记完成，避免该 Category 在预加载失败后一直无法参与过滤
        const target = this.allCategories[categoryName];
        if (target !== undefined) target.subCategoriesLoaded = true;
        console.error('获取分类组件失败！', categoryName, error);
      }).then(() => {
        delete this.pendingCategoryLoads[categoryName];
      });
      this.pendingCategoryLoads[categoryName] = loading;
      return loading;
    },
    // 预加载所有 Category 的组件数据，使切换 Rhino 版本时 tab 的显示/隐藏无需等待
    preloadAllCategories() {
      return Promise.all(this.categories.map(category => this.loadCategoryComponents(category.name)));
    },
    // 确保当前选中的 Category 在当前 Rhino 版本下仍然可见
    ensureCurrentCategoryVisible() {
      if (this.visibleCategories.length === 0) return;
      const isStillVisible = this.visibleCategories.some(category => category.name === this.currentTabName);
      if (isStillVisible) return;
      const target = this.visibleCategories[0];
      this.setCurrentCategory(target.name);
      // 同步路由，避免地址栏与实际显示的分类不一致
      const toolsetName = get_toolset_name_from_full_path(this.$route.path);
      const path = `${appPath}${toolsetName}/${target.name}/`;
      if (this.$route.path !== path) {
        this.$router.push({
          path
        });
      }
    },
    initCurrentCategory() {
      if (this.$route.params.categoryName === undefined) {
        let categoryName = this.categories[0].name;
        this.setCurrentCategory(categoryName);
        return;
      }
      this.setCurrentCategory(this.$route.params.categoryName);
    },
    initCurrentComponent() {
      if (this.$route.params.nameInUrl === undefined) {
        return;
      }
      this.isCompLoading = true;
      this.setCurrentComponent(this.$route.params.categoryName, this.$route.params.nameInUrl);
    },
    async setCurrentComponent(categoryName, nameInUrl) {
      if (this.allComponents[categoryName] === undefined) {
        this.allComponents[categoryName] = [];
      }
      if (this.allComponents[categoryName][nameInUrl] !== undefined) {
        this.currentComponent = this.allComponents[categoryName][nameInUrl];
      } else {
        await get_component_from_name(categoryName, nameInUrl).then(result => {
          this.currentComponent = result;
          this.allComponents[categoryName][nameInUrl] = result;
        });
      }
      this.isCompLoading = false;
      this.applyParamTableCollapseDefault();
      this.syncHighlightedIcon();
      // Add this line to trigger the watcher
      this.$nextTick(() => {
        this.currentComponent = {
          ...this.currentComponent
        };
      });
    },
    // 让图标区里当前组件的图标保持高亮。
    // 高亮原本只在点击图标时写入 Vuex，所以刷新浏览器、直接输入组件网址、
    // 从搜索框点进来这三种途径都不会高亮。这里以路由为准重新对齐：
    // 这三条路径最终都会走到 setCurrentComponent，在这里同步一次就都覆盖了。
    // 组件不在当前分类的图标区里（比如从搜索结果跨分类点进来）时不会有高亮，
    // 这是合理的，不该凭空点亮一个用户看不见的图标。
    syncHighlightedIcon() {
      const id = this.currentComponent && this.currentComponent.id;
      // 没加载到组件时保持原值，避免请求失败把已有高亮清掉
      if (id === undefined || id === null) {
        return;
      }
      this.$store.dispatch('updateHighlightedIconId', id);
      this.revealHighlightedIcon();
    },
    // 图标区卷起时，若高亮图标落在渐隐带（被遮罩）里，把它滚进实心段。
    // 搜索跳转时会走到这里：组件可能位于图标区很靠下的位置，卷起状态下
    // 用户看不到自己点的是哪个，滚动定位一下就不会失去上下文。
    // 已经在实心段内则不动，避免每次跳转都无谓地滚动。
    revealHighlightedIcon() {
      if (!this.iconsCollapsed) {
        return;
      }
      // 高亮是 Vuex 驱动的，dispatch 之后要等一次渲染才能在 DOM 里查到；
      // 跨分类跳转时图标区的子分类是异步加载的，所以要重试几次
      this.$nextTick(() => {
        this.tryRevealHighlightedIcon(0);
      });
    },
    tryRevealHighlightedIcon(attempt) {
      const area = this.visibleCollapsedArea();
      const target = area && area.querySelector('.GHOperator.highlighted');
      // 分类还在加载：图标还没渲染出来，稍后再试（最多约 1.2 秒）
      if (!target && attempt < 6) {
        setTimeout(() => {
          this.tryRevealHighlightedIcon(attempt + 1);
        }, 200);
        return;
      }
      if (!target) {
        return;
      }
      const solid = parseFloat(getComputedStyle(area).getPropertyValue('--collapsed-solid')) || area.clientHeight;
      const viewportTop = target.getBoundingClientRect().top - area.getBoundingClientRect().top;
      // 完整落在实心段内就不用滚，只差一点点也保持不动，免得每次跳转都晃一下
      if (viewportTop >= 0 && viewportTop + target.offsetHeight <= solid) {
        return;
      }
      const contentTop = viewportTop + area.scrollTop;
      const maxScroll = area.scrollHeight - area.clientHeight;
      area.scrollTo({
        top: Math.max(0, Math.min(contentTop - 8, maxScroll)),
        behavior: 'auto'
      });
    },
    // 搜索跳转后的聚焦动效：先把页面滚回图标区，让目标图标闪一圈光晕，
    // 再滚到组件详情。
    // 入口是 searchNavigationId 而不是 currentComponent：搜索结果里已经带着
    // 组件 id，不必等后端把组件详情取回来。早一步开始，用户点完搜索就能
    // 立刻看到反馈，而不是等一两秒后光晕才突然亮起。
    focusIconFromSearch(id) {
      // 同一轮只跑一次（重试会反复走到这里）
      if (this.focusingIconId === id) {
        return;
      }
      this.focusingIconId = id;
      // 连点搜索时先掐掉上一次未完成的流程
      this.clearFocusTimers();
      this.tryFocusSearchIcon(id, 0);
    },
    // 目标图标可能还没进 DOM，也可能进了 DOM 但所在 tab 还没激活。
    // 跨 Tab 搜索时最容易踩后者：图标元素已经渲染在 display:none 的 tab-pane 里，
    // 这时打光晕动画是在隐藏元素上白播，用户看不到；而遮罩要在当前可见的
    // 图标区里找孔，找到的是旧 tab，找不到就干脆不渲染——结果就是「只有放大
    // 动画、没有压暗」。所以判据必须是「可见」，不是「存在」，且要一直等到
    // tab 切好、子分类加载完（最多约 1.8 秒）。
    tryFocusSearchIcon(id, attempt) {
      const target = this.$el.querySelector(`.GHOperator[data-id="${id}"]`);
      const visible = !!target && target.offsetParent !== null;
      if (!visible && attempt < 12) {
        this.pushFocusTimer(() => this.tryFocusSearchIcon(id, attempt + 1), 150);
        return;
      }
      if (!visible) {
        // 图标始终没出现（比如该组件不在当前 Rhino 版本里）：放弃动效，直接给详情
        this.$store.dispatch('setFocusIcon', null);
        this.$store.dispatch('clearSearchNavigation');
        this.focusingIconId = null;
        this.pushFocusTimer(() => this.scrollToCurrentComponent(), 0);
        return;
      }
      // 标记已消费。留着的话这个值不变、watcher 不会再触发，但下次点普通图标
      // 时它会继续挂在 store 里成为误导性的状态
      this.$store.dispatch('clearSearchNavigation');
      // 先把图标区滚进视野，再放光晕。顺序不能反：图标区如果此时在视口外，
      // 用户看到的是「页面在动」，等滚动停下来才发现有光晕，指向感就弱了。
      this.scrollIconAreaIntoView();
      // 图标区卷起时目标图标可能落在渐隐带里，光晕会被吃掉。直接对已拿到的
      // 元素调用，不走 revealHighlightedIcon——那个方法内部是异步重试，
      // 会把光晕的起点拖到一两秒后，和「滚回详情」撞在一起。
      this.revealTargetIconNow(target);
      // 点亮必须排在滚动之后：focusMaskStyle 是 computed，靠 focusIconId 触发
      // 一次求值就把孔的坐标算死了。而上面的滚动改的是图标区内部的 scrollTop，
      // 目标图标相对遮罩的位置随之变化——先点亮就会按旧坐标定位孔，看起来错位。
      this.$store.dispatch('setFocusIcon', id);
      this.pushFocusTimer(() => {
        this.$store.dispatch('setFocusIcon', null);
        // 重置守卫，否则再次搜索同一个组件会被当成「同一轮」而跳过动效
        this.focusingIconId = null;
        this.scrollToCurrentComponent();
      }, 1900);
    },
    // 立即把指定图标滚进卷起状态下的实心段（对照 revealHighlightedIcon，
    // 那个是给路由跳转用的、要等 DOM，这里元素已经拿到了，可以直接算）
    revealTargetIconNow(target) {
      const area = this.visibleCollapsedArea();
      if (!area || !area.contains(target)) {
        return;
      }
      const solid = parseFloat(getComputedStyle(area).getPropertyValue('--collapsed-solid')) || area.clientHeight;
      const viewportTop = target.getBoundingClientRect().top - area.getBoundingClientRect().top;
      if (viewportTop >= 0 && viewportTop + target.offsetHeight <= solid) {
        return;
      }
      const contentTop = viewportTop + area.scrollTop;
      const maxScroll = area.scrollHeight - area.clientHeight;
      area.scrollTo({
        top: Math.max(0, Math.min(contentTop - 8, maxScroll)),
        behavior: 'auto'
      });
    },
    // 把图标区连同 tab 标签栏一起滚到视口顶部。
    // 搜索结果可能来自任意分类，而点击图标跳转时页面已经停在了组件详情上，
    // 目标图标往往在视口之外。
    // 目标是「标签栏顶边刚好贴在 sticky 顶栏下沿」而不是「滚到屏幕最顶端」：
    // #header 是 position:sticky、始终占着视口顶部，滚到 0 会把它盖在
    // 标签栏上面，看起来就少了第一行分类名。所以要减去 header 的实际高度。
    // 用 instant 而不是 smooth：平滑滚动有几百毫秒的动画期，这期间还会被浏览器的
    // 焦点自动滚动抢一把，停下来时经常停在半路——标签栏露出来了，却和顶栏之间
    // 还隔着一段，看着像没滚到位。瞬时定位没有中间态，落下就是最终位置。
    // 已经就位时不再动，否则每次搜索都会白跳一下。
    scrollIconAreaIntoView() {
      const wrapper = this.$el.querySelector('.tabs-wrapper');
      if (!wrapper) {
        return;
      }
      const header = document.getElementById('header');
      const headerH = header ? header.offsetHeight : 0;
      const currentTop = wrapper.getBoundingClientRect().top;
      if (Math.abs(currentTop - headerH) < 4) {
        return;
      }
      const targetY = Math.max(0, currentTop + window.scrollY - headerH);
      window.scrollTo({
        top: targetY,
        behavior: 'auto'
      });
    },
    pushFocusTimer(fn, delay) {
      this.focusTimers.push(setTimeout(fn, delay));
    },
    clearFocusTimers() {
      this.focusTimers.forEach(t => clearTimeout(t));
      this.focusTimers = [];
    },
    // 切换组件后的参数表格默认状态：
    // 1. 未更新的组件（图标上会提示 To be updated，即 is_enable 为 false）只是占位，
    //    参数表格直接展开；
    // 2. 已更新的组件：下方有范例内容时折叠，让用户先看到范例；没有范例内容时展开。
    // 桌面端和移动端一致。
    // 单行参数不参与折叠（canCollapse* 为 false），这里也要强制展开，
    // 否则从多行组件切过来时残留的 true 会让单行表格带着遮罩显示。
    applyParamTableCollapseDefault() {
      const isPlaceholder = this.currentComponent && this.currentComponent.is_enable === false;
      const collapsed = !isPlaceholder && this.hasBottomContent;
      this.inputTableCollapsed = collapsed && this.canCollapseInput;
      this.outputTableCollapsed = collapsed && this.canCollapseOutput;
    },
    updateCurrentComponent(nameInUrl, id) {
      const toolsetName = get_toolset_name_from_full_path(this.$route.path);
      const to = {
        path: `${appPath}${toolsetName}/${this.currentCategory.name}/${nameInUrl}`
      };
      this.$router.push(to).catch(err => {
        console.error('路由跳转失败:', err);
      });
      this.$store.dispatch('updateHighlightedIconId', id);
    },
    // 卷起/展开图标区。卷起时顺带把当前组件的图标滚进实心区，
    // 否则用户刚点完就卷起，图标多半落在渐隐带或视口外，看不到自己选的是哪个
    toggleIconArea() {
      this.iconsCollapsed = !this.iconsCollapsed;
      if (this.iconsCollapsed) {
        this.$nextTick(() => {
          this.scrollIconAreaBackIntoViewport();
          this.waitForCollapseThenReveal();
        });
      }
    },
    // 点击组件后页面会自动上滚，让组件详情顶上来（scrollToCurrentComponent），
    // 图标区和下面的卷起按钮都被推出视野。此时卷起要把页面拉回图标区，
    // 否则用户点了卷起却什么都没发生——按钮不在眼前，图标区也看不见。
    // 只有图标区确实已经滚出视野时才动页面，避免打断正常的浏览位置
    scrollIconAreaBackIntoViewport() {
      const wrapper = this.$el.querySelector('.tabs-wrapper');
      if (!wrapper) {
        return;
      }
      // 顶部导航栏是 static 定位（会随页面滚走），不是 fixed，
      // 所以这里只需要让图标区回到视口顶，不用给导航栏留高度
      const alreadyVisible = wrapper.getBoundingClientRect().top >= 0;
      if (alreadyVisible) {
        return;
      }
      window.scrollTo({
        top: Math.max(0, wrapper.getBoundingClientRect().top + window.scrollY),
        behavior: 'smooth'
      });
    },
    // 必须等 max-height 过渡真正结束再滚：过渡期间 clientHeight 还是满的，
    // scrollHeight - clientHeight 为 0，目标位置会被钳到顶部。
    // 用 transitionend 而不是固定 setTimeout——点击图标会触发 Vue 重渲染 tab-pane，
    // 过渡的起点会被推迟，固定延时会早于它（实测 400ms 时 maxScroll 仍是 0）。
    // 兜底超时取 1s，样式里的过渡是 .35s，正常不会走到这里
    waitForCollapseThenReveal() {
      const area = this.visibleCollapsedArea();
      if (!area) {
        return;
      }
      let done = false;
      const finish = () => {
        if (done) {
          return;
        }
        done = true;
        area.removeEventListener('transitionend', onEnd);
        clearTimeout(timer);
        this.scrollHighlightedIconIntoView();
      };
      const onEnd = e => {
        // 只认 max-height 这一条，opacity 之类别的过渡结束不算
        if (e.propertyName === 'max-height') {
          finish();
        }
      };
      area.addEventListener('transitionend', onEnd);
      const timer = setTimeout(finish, 1000);
    },
    // 当前可见且处于卷起态的图标区的滚动容器。
    // 每个 tab-pane 里都有一份图标区，隐藏的那些 offsetParent 为 null，必须筛掉。
    // 返回的是 el-scrollbar 内部的 wrap 而不是 .icon-area：卷起时的纵向滚动和
    // 渐隐遮罩都挂在 wrap 上（见样式里的说明），scrollTop 也就在它身上。
    visibleCollapsedArea() {
      const areas = this.$el.querySelectorAll('.icon-area.is-collapsed');
      const area = Array.prototype.find.call(areas, el => el.offsetParent !== null);
      return area ? area.querySelector('.el-scrollbar__wrap') : null;
    },
    // 卷起/展开（以及改行数）都是在 wrap 上做 max-height 过渡，el-scrollbar 只在
    // 内容尺寸或窗口尺寸变化时重算滑块，察觉不到 wrap 自己变矮了，
    // 纵向滑块会停留在过渡前的长度。过渡结束后手动让它重算一次。
    updateIconScrollbars(e) {
      if (e && (e.propertyName !== 'max-height' || !e.target.classList.contains('el-scrollbar__wrap'))) {
        return;
      }
      const bars = [].concat(this.$refs.iconScrollbar || []);
      bars.forEach(bar => bar && bar.update && bar.update());
    },
    // 把带 .highlighted 的图标滚到图标区未被遮罩的实心段里。
    // 实心段高度 = --collapsed-solid（当前是 120px），渐隐带在它下面；
    // 目标位置留 8px 余量，让图标下方还能看到一点同排的邻居
    scrollHighlightedIconIntoView() {
      const area = this.visibleCollapsedArea();
      if (!area) {
        return;
      }
      const target = area.querySelector('.GHOperator.highlighted');
      // 没有高亮图标 = 用户还没点过（直接进 URL），保持原来的滚动位置不动
      if (!target) {
        return;
      }
      const padding = 8;
      // rect 差值给的是图标在视口内的位置，要换算成内容坐标必须再加上当前 scrollTop；
      // 否则用户此前手动滚动过时，目标位置会被算小（图标落在渐隐带里）
      const viewportTop = target.getBoundingClientRect().top - area.getBoundingClientRect().top;
      const contentTop = viewportTop + area.scrollTop;
      const maxScroll = area.scrollHeight - area.clientHeight;
      // 滚到「让图标顶部落在实心段起点 + padding」这个位置，
      // 再夹进 [0, maxScroll]：列表末尾没那么多内容时只能靠底显示，
      // 强制对齐顶部反而会越过 maxScroll 被浏览器拉回
      area.scrollTo({
        top: Math.max(0, Math.min(contentTop - padding, maxScroll)),
        // 瞬时而不是 smooth：跳转组件后组件区会做一次 window 平滑滚动，
        // smooth 的图标区滚动会被排到那次动画之后，实测要等 3 秒才生效
        behavior: 'auto'
      });
    },
    scrollToCurrentComponent() {
      if (this.$refs.currentComponentDisplay && !this.isCompLoading) {
        const element = this.$refs.currentComponentDisplay;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - 160;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },
    handleBreadcrumbClick(event) {
      // Prevent the default routing behavior
      event.preventDefault();
      // Execute the scroll to top action
      this.scrollToTop();
      this.$router.push(event.target.getAttribute('href'));
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    initGifControls() {
      this.$nextTick(() => {
        const containers = this.$el.querySelectorAll('.text-container, .image-container');
        containers.forEach(container => {
          const images = container.querySelectorAll('img');
          images.forEach(img => {
            const src = img.src || '';
            const srcNoQuery = src.split('?')[0].toLowerCase();
            const isGif = srcNoQuery.endsWith('.gif') || src.toLowerCase().includes('data:image/gif');
            if (!img.src || !isGif) return;
            if (img.closest('.gif-wrapper')) return;
            const wrapper = document.createElement('div');
            wrapper.className = 'gif-wrapper';
            const badge = document.createElement('span');
            badge.className = 'gif-badge';
            badge.innerHTML = 'GIF';
            img.parentNode.insertBefore(wrapper, img);
            wrapper.appendChild(img);
            wrapper.appendChild(badge);

            // 设置 CORS 属性，使 Canvas 截图和 libgif.js 能处理跨域 GIF
            if (!img.crossOrigin && !src.toLowerCase().includes('data:image/gif')) {
              img.crossOrigin = 'anonymous';
            }
            const originalSrc = img.src;

            // 鼠标悬停时才解析，减少初始加载开销
            let isInitialized = false;
            const handleMouseEnter = () => {
              if (isInitialized) return;

              // 验证 crossOrigin 是否已生效，若未生效则等待图片重新加载
              if (img.crossOrigin && img.complete) {
                try {
                  const testCanvas = document.createElement('canvas');
                  testCanvas.width = 1;
                  testCanvas.height = 1;
                  testCanvas.getContext('2d').drawImage(img, 0, 0, 1, 1);
                  testCanvas.toDataURL();
                } catch (e) {
                  const currentSrc = img.src;
                  const originalOnLoad = img.onload;
                  img.onload = () => {
                    img.onload = originalOnLoad;
                    handleMouseEnter();
                  };
                  img.onerror = () => {
                    img.onload = originalOnLoad;
                    handleMouseEnter();
                  };
                  img.src = '';
                  img.src = currentSrc;
                  return;
                }
              }
              isInitialized = true;
              const overlay = document.createElement('div');
              overlay.className = 'gif-overlay';
              overlay.style.opacity = '1';
              const loading = document.createElement('div');
              loading.className = 'gif-loading';
              loading.innerHTML = 'Loading';
              overlay.appendChild(loading);
              wrapper.appendChild(overlay);

              // 截取当前 GIF 画面作为加载时的静态占位图
              let staticFrame = null;
              const w = img.naturalWidth || img.width;
              const h = img.naturalHeight || img.height;
              if (w && h) {
                try {
                  const c = document.createElement('canvas');
                  c.width = w;
                  c.height = h;
                  c.getContext('2d').drawImage(img, 0, 0, w, h);
                  const dataUrl = c.toDataURL('image/png');
                  staticFrame = document.createElement('img');
                  staticFrame.src = dataUrl;
                  staticFrame.className = 'gif-static-frame';
                  staticFrame.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;z-index:2;pointer-events:none;';
                  wrapper.appendChild(staticFrame);
                } catch (e) {
                  console.warn('[GIF] Static frame capture failed:', e.message);
                }
              }
              const rub = new SuperGif({
                gif: img,
                auto_play: false,
                loop_mode: true,
                show_progress_bar: false,
                draw_while_loading: false
              });
              rub.load(success => {
                if (staticFrame) {
                  staticFrame.remove();
                  staticFrame = null;
                }
                if (!success) {
                  // 解析失败：清理控制元素，恢复为普通 GIF 展示
                  overlay.remove();
                  const jsgifDiv = wrapper.querySelector('.jsgif');
                  if (jsgifDiv) jsgifDiv.remove();
                  if (!wrapper.contains(img)) {
                    wrapper.appendChild(img);
                  }
                  return;
                }
                overlay.innerHTML = '';
                overlay.style.opacity = '';
                const btnGroup = document.createElement('div');
                btnGroup.style.cssText = 'display:flex;gap:12px;align-items:center;';
                const btn = document.createElement('button');
                btn.className = 'gif-toggle-btn';
                btn.innerHTML = '▶';
                btn.title = 'Play';
                const restartBtn = document.createElement('button');
                restartBtn.className = 'gif-toggle-btn';
                restartBtn.innerHTML = '↺';
                restartBtn.title = 'Replay';
                btnGroup.appendChild(btn);
                btnGroup.appendChild(restartBtn);
                overlay.appendChild(btnGroup);
                const progressBar = document.createElement('div');
                progressBar.className = 'gif-progress-bar';
                const progressFill = document.createElement('div');
                progressFill.className = 'gif-progress-fill';
                progressBar.appendChild(progressFill);
                wrapper.appendChild(progressBar);
                const updateProgress = () => {
                  if (!progressBar.isConnected) return;
                  const total = rub.get_length();
                  const current = rub.get_current_frame();
                  if (total > 0) {
                    progressFill.style.width = (current + 1) / total * 100 + '%';
                  }
                  requestAnimationFrame(updateProgress);
                };
                requestAnimationFrame(updateProgress);
                let isPlaying = false;
                btn.addEventListener('click', e => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (isPlaying) {
                    rub.pause();
                    btn.innerHTML = '▶';
                    btn.title = 'Play';
                    isPlaying = false;
                  } else {
                    rub.play();
                    btn.innerHTML = '❚❚';
                    btn.title = 'Pause';
                    isPlaying = true;
                  }
                });
                restartBtn.addEventListener('click', e => {
                  e.preventDefault();
                  e.stopPropagation();
                  rub.move_to(0);
                  rub.play();
                  btn.innerHTML = '❚❚';
                  btn.title = 'Pause';
                  isPlaying = true;
                });
                this.gifPlayers.push({
                  wrapper,
                  rub,
                  originalSrc
                });
              });
            };
            wrapper.addEventListener('mouseenter', handleMouseEnter, {
              once: true
            });
          });
        });
      });
    },
    destroyGifControls() {
      this.gifPlayers.forEach(p => {
        if (p.rub) p.rub.pause();
      });
      this.gifPlayers = [];
    }
  }
});